module.exports = __webpack_public_path__ + "img/rubico_white.d1283afd.png";